import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize, timeout } from 'rxjs/operators';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';

let serviceCount = 0;

export const interceptorFn: HttpInterceptorFn = (
  request: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const toastr = inject(ToastrService);
  const router = inject(Router);
  const ngxUiLoaderService = inject(NgxUiLoaderService);
  const storageService = inject(StorageService);
  const loader = ngxUiLoaderService.getLoader();

  serviceCount++;
  if (
    !request.url.includes('masters/patients/list') &&
    !request.url.includes('/masters?DdlType=') &&
    !request.url.includes('/masters?DdlType=Specialty')
  ) {
    if (loader && loader.loaderId) {
      ngxUiLoaderService.startLoader(loader.loaderId);
    }
  }

  const userToken = storageService.get('token');
  if (userToken) {
    request = request.clone({
      setHeaders: { Authorization: `Bearer ${userToken}` },
    });
  }

  return next(request).pipe(
    timeout(9000),
    finalize(() => {
      serviceCount--;

      if (serviceCount === 0) {
        if (loader?.loaderId) {
          ngxUiLoaderService.stopLoader(loader.loaderId);
        }
      }
    }),
    catchError((error) => {
      return handleAuthError(
  error,
  toastr,
  router,
  ngxUiLoaderService,
  storageService,
  loader
);
    }) as any,
  );
};

function handleAuthError(
  err: any,
  toastr: ToastrService,
  router: Router,
  ngxUiLoaderService: NgxUiLoaderService,
  storageService: StorageService,
  loader: any,
): Observable<any> {
if (err.status === 401) {
  toastr.error(
    err.error?.message || 'Session expired. Please login again.',
    '',
    { timeOut: 5000 }
  );

  localStorage.clear();
  sessionStorage.clear();
  storageService.clear();

  ngxUiLoaderService.stopAll();

  router.navigate(['/login']);

  return throwError(() => err);
}
  if (err.status === 403) {
    setTimeout(() => {
      ngxUiLoaderService.stop();
    }, 500);

    toastr.error(err.error.message, 'Error!', {
      timeOut: 5000,
    });

    return of(err.message);
  }

  if (err.status === 500) {
    setTimeout(() => {
      if (loader && loader.loaderId) {
        ngxUiLoaderService.stopLoader(loader.loaderId);
      } else {
        ngxUiLoaderService.stopAll();
      }
    }, 500);
    let msg = err.error.message
      ? err.error.message
      : 'Something went wrong! Please contact system admin.';
    toastr.error(msg, 'Error!', { timeOut: 5000 });

    return throwError(() => err);
  }

  if (err.status == 400) {
    setTimeout(() => {
      ngxUiLoaderService.stopLoader(loader.loaderId);
    }, 200);
    ngxUiLoaderService.stopAll();

    if (err.url?.includes('/appointment')) {
      toastr.warning(
        err.error.Message ?? err.error.message,
        'Warning!',
        { timeOut: 2000 },
      );
    } else {
      toastr.error(err.error.Message ?? err.error.message, 'Error!', {
        timeOut: 2000,
      });
    }

    return throwError(() => err.error.Message);
  }

  if ([410, 404, 409, 405].indexOf(err.status) != -1) {
    setTimeout(() => {
      if (loader?.loaderId) {
        ngxUiLoaderService.stopLoader(loader.loaderId);
      } else {
        ngxUiLoaderService.stopAll();
      }
    }, 200);

    toastr.error(err.error.Message ?? err.error.message, 'Error!');
    return throwError(err.error.Message);
  }

  if (err.status == 0) {
    setTimeout(() => {
      ngxUiLoaderService.stopAll();
    }, 500);

    setTimeout(
      () => ngxUiLoaderService.stopLoader(loader.loaderId),
      500,
    );

    toastr.error('Network Issue Or Some Error Occured', 'Error!', {
      timeOut: 5000,
    });
    return of('Some Error Occured');
  }
  throw err;
}

